import { useSeo } from '@/hooks/useSeo';
import JsonLd from './JsonLd';

/**
 * Central SEO manager: applies route-aware head metadata (title, description,
 * keywords, canonical, OG, Twitter) and injects Schema.org JSON-LD.
 */
export default function SeoManager() {
  useSeo();
  return <JsonLd />;
}